const categories = [
    {
        id: 1,
        name: 'Laptop',
        image: 'https://vcdn-sohoa.vnecdn.net/2022/01/10/image003-1641818687-3224-1641818834.png',
        iconName: 'faLaptop',
    },
    {
        id: 2,
        name: 'Desktop',
        image: 'https://i.dell.com/is/image/DellContent//content/dam/ss2/product-images/dell-client-products/desktops/inspiron-desktops/27-7790/general/new-category-page-desktop-black-inspiron-27-7790-3880-800x620.png?fmt=png-alpha&wid=800&hei=620',
        iconName: 'faComputer',
    },
    {
        id: 3,
        name: 'Smartphone',
        image: 'https://cdn-www.mediatek.com/page/Mobile-2_2021-10-20-155734_vspa.png',
        iconName: 'faMobileScreen',
    },
    {
        id: 4,
        name: 'Tablet',
        image: 'https://p4-ofp.static.pub/fes/cms/2022/02/10/mzr7bhnqxvv3n35809y8blhsklcjpj515071.png',
        iconName: 'faTabletScreenButton',
    },
    {
        id: 5,
        name: 'Monitor',
        image: 'https://images.samsung.com/is/image/samsung/p6pim/in/lf24t350fhwxxl/gallery/in-t35f-407326-lf24t350fhwxxl-530436998?$650_519_PNG$',
        iconName: 'faTv',
    },
    {
        id: 6,
        name: 'Mouse',
        image: 'https://resource.logitechg.com/w_1206,c_limit,q_auto,f_auto,dpr_1.0/d_transparent.gif/content/dam/gaming/en/products/g502x-lightspeed/gallery/g502x-lightspeed-gallery-1-black.png?v=1',
        iconName: 'faComputerMouse',
    },
    {
        id: 7,
        name: 'Keyboard',
        image: 'https://cdn2.cellphones.com.vn/x358,webp,q100/media/catalog/product/1/_/1_52_7.png',
        iconName: 'faKeyboard',
    },
    {
        id: 8,
        name: 'Gamepad',
        image: 'https://resource.logitechg.com/w_692,c_limit,q_auto,f_auto,dpr_1.0/d_transparent.gif/content/dam/gaming/en/products/f310/f310-gallery-1.png?v=1',
        iconName: 'faGamepad',
    },
    {
        id: 9,
        name: 'In-ear',
        image: 'https://anhduy.vn/upload/sanpham/image_1582648849.jpg',
        iconName: 'faHeadphonesSimple',
    },
    {
        id: 10,
        name: 'Over-ear',
        image: 'https://amthanhhay.com.vn/wp-content/uploads/2021/04/Bose-SoundLink-around-ear-wireless-II-3-600x511.png',
        iconName: 'faHeadphones',
    },
    {
        id: 11,
        name: 'Speaker',
        image: 'https://image01.realme.net/general/20211011/1633932676027.png.webp',
        iconName: 'faSpeakerDeck',
    },
];
export default categories;
